import type { ITableColumn } from '../../components/Table/utils/types';
import type { IColumn, IFormilySchema } from '../types';
import { extractColumnsFromSchema } from './extractColumnsFromSchema';
import { filterVisibleColumns } from './filterVisibleColumns';
import { mapToTableColumns } from './mapToTableColumns';

export interface ITableSortState {
  sortName?: string;
  sortOrder?: 'ascend' | 'descend';
}

export const buildTableColumns = <T extends Record<string, unknown>>(
  propsColumns: IColumn[] | undefined,
  childSchema: IFormilySchema | undefined,
  context?: any,
  rowName?: string,
  sort?: ITableSortState
): ITableColumn<T>[] => {
  const sourceColumns =
    propsColumns && propsColumns.length > 0
      ? propsColumns
      : extractColumnsFromSchema(childSchema);

  const visibleColumns = filterVisibleColumns(sourceColumns);

  return mapToTableColumns<T>({
    columns: visibleColumns,
    context: context || {},
    rowName,
    sortName: sort?.sortName,
    sortOrder: sort?.sortOrder,
  });
};
